import CustomElement from '~utilities/custom-element';

class ScrollIcon extends CustomElement {
    constructor() {
        super();
    }

    template() {
        return `
          <div class="c-scroll-icon" data-text="${this.getAttribute('js-text')}"></div>
        `;
    }


    callback() {
        super.callback();

        this.bindEvents();
    }

    bindEvents(){
      this.content = document.querySelector('c-content');
      this.content.addEventListener('scroll', () => this.throttleScroll(), {passive: true});
    }

    throttleScroll(event) {
	    if(this.scrollInterval){
		    window.clearTimeout(this.scrollInterval);
		  };
	    this.scrollInterval = setTimeout(() => {
		    this.scrollElement(event);
	    },10);
    }

    scrollElement() {
      const toggleTop = this.content.scrollTop > 150 ? 'add' : 'remove' ;
      this.element.classList[toggleTop]('is--hidden');
    }

}

export default ScrollIcon;
